// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__AJ_CH","image":"style_image__YtG2p"};